<template>
  <div class="flex items-start">
    <div class="flex-shrink-0">
      <svg
        class="h-6 w-6 text-gray-400 stroke-current"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
        ></path>
      </svg>
    </div>
    <div class="ml-3 w-0 flex-1 pt-0.5">
      <p class="text-sm leading-5 font-medium text-gray-900">
        Comment Added
      </p>
      <p class="mt-1 text-sm leading-5 text-gray-500">
        {{ notification.details.userDisplay }} commented on your shared project
      </p>
      <div class="mt-2">
        <router-link :to="link">
          <button
            class="text-sm leading-5 font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
          >
            View
          </button>
        </router-link>
        <button
          @click="dismissNotification"
          class="ml-6 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:underline transition ease-in-out duration-150"
        >
          Dismiss
        </button>
      </div>
    </div>
    <div class="ml-4 flex-shrink-0 flex">
      <button
        @click="dismissNotification"
        class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
      >
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentAddedNotification",
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    dismissNotification() {
      this.$emit("dismiss-notification", this.notification.id);
    }
  },
  computed: {
    link() {
      return `/project/${this.notification.details.project}`;
    }
  }
};
</script>

<style scoped></style>
